import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityLogService {

  constructor(public hs: HttpService) { }

  async get_list(filters: any) {
    try {
      let response = await this.hs.get('/activity-log/get-activity-log-list', filters)
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
